export default {
  init() {
    // JavaScript to be fired on a product page
    $('.media-col img.smaller').click(function(e) {
      e.preventDefault();
      var smaller = $(this);
      var loop_id = smaller.data('loop-id');
      $('.media-col img.smaller.active').removeClass('active');
      smaller.addClass('active');
      $('.primary-image').removeClass('active');
      $('#primary-' + loop_id).addClass('active');
    });

    // video carousel on single product page
    $('.video-carousel').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: false,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });
  },
  finalize() {
    // JavaScript to be fired on the product page, after the init JS
  },
};
